var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_vm._m(0),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spin fa-spinner"})])
}]

export { render, staticRenderFns }